import { defineMessages } from 'react-intl';

export default defineMessages({
  importantAnnouncement: {
    id: 'announcement.important',
    description: 'new important announcements',
    defaultMessage: 'new important announcements',
  },
  viewButton: {
    id: 'announcement.view',
    description: 'view',
    defaultMessage: 'View',
  },
});
